import * as React from 'react'
import * as ReactRouterDom from 'react-router-dom'

export function PasswordResetContainer() {
  const history = ReactRouterDom.useHistory()
  const {token} = ReactRouterDom.useParams()

  React.useEffect(() => {
    history.push(`/?password-reset=${token}`)
  }, [token, history])

  return null
}

// for @loadable/component
export default PasswordResetContainer
